import React from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider } from './context/AuthContext';
import { FeatureProvider } from './context/FeatureContext';
import { TradingProvider } from './context/TradingContext';
import Layout from './components/Layout';
import ScrollToTop from './components/ScrollToTop';
import Dashboard from './pages/Dashboard';
import ModelDetail from './pages/ModelDetail';
import DocsOverview from './pages/docs/Overview';
import DocsHowItWorks from './pages/docs/HowItWorks';
import DocsLeaderboard from './pages/docs/LeaderboardSystem';
import DocsLLMIntegration from './pages/docs/LLMIntegration';
import DocsDecisionProcess from './pages/docs/DecisionProcess';
import DocsPositionManagement from './pages/docs/PositionManagement';
import DocsSupportedModels from './pages/docs/SupportedModels';
import DocsTextVsVision from './pages/docs/TextVsVision';
import DocsScoringSystem from './pages/docs/ScoringSystem';
import DocsFAQ from './pages/docs/FAQ';
import DocsChangelog from './pages/docs/Changelog';
import DocsApiReference from './pages/docs/ApiReference';
import TermsPage from './pages/legal/TermsPage';
import PrivacyPage from './pages/legal/PrivacyPage';

function App() {
  return (
    <AuthProvider>
      <FeatureProvider>
        <TradingProvider>
        <ScrollToTop />
        <Layout>
          <Routes>
            {/* Public routes */}
            <Route path="/" element={<Dashboard />} />
            <Route path="/model/:id" element={<ModelDetail />} />
            <Route path="/docs" element={<DocsOverview />} />
            <Route path="/docs/how-it-works" element={<DocsHowItWorks />} />
            <Route path="/docs/leaderboard" element={<DocsLeaderboard />} />
            <Route path="/docs/llm-integration" element={<DocsLLMIntegration />} />
            <Route path="/docs/decision-process" element={<DocsDecisionProcess />} />
            <Route path="/docs/position-management" element={<DocsPositionManagement />} />
            <Route path="/docs/models" element={<DocsSupportedModels />} />
            <Route path="/docs/text-vs-vision" element={<DocsTextVsVision />} />
            <Route path="/docs/scoring" element={<DocsScoringSystem />} />
            <Route path="/docs/faq" element={<DocsFAQ />} />
            <Route path="/docs/changelog" element={<DocsChangelog />} />
            <Route path="/docs/api" element={<DocsApiReference />} />

            {/* Legal pages */}
            <Route path="/terms" element={<TermsPage />} />
            <Route path="/privacy" element={<PrivacyPage />} />

            {/* Auth routes - redirect to home */}
            <Route path="/login" element={<Navigate to="/" replace />} />
            <Route path="/register" element={<Navigate to="/" replace />} />
            <Route path="/verify-email" element={<Navigate to="/" replace />} />
            <Route path="/profile" element={<Navigate to="/" replace />} />
            <Route path="/subscription" element={<Navigate to="/" replace />} />
            <Route path="/subscription/success" element={<Navigate to="/" replace />} />
            <Route path="/subscription/cancel" element={<Navigate to="/" replace />} />
          </Routes>
        </Layout>
        </TradingProvider>
      </FeatureProvider>
    </AuthProvider>
  );
}

export default App;
